jQuery(document).ready(function(){

	jQuery('.testimonials-slider').slick({
		slidesToShow: 2,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 2000,
		responsive: [
		{
			breakpoint: 640,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1
			}
		}
		]
	});

	wow = new WOW({
								boxClass:     'wow',
								animateClass: 'animated',
								offset:       0,
								mobile:       false,
								live:         true
							});
	wow.init();

	//magpop
	jQuery('a[href*=".jpg"], a[href*=".jpeg"], a[href*=".png"], a[href*=".gif"]').each(function(){
		//single image popup
		if (jQuery(this).parents('.gallery').length == 0) {
			jQuery(this).magnificPopup({type:'image'});
		}
	});

	//gallery popup
	jQuery('.gallery').each(function() {
		jQuery(this).magnificPopup({
			delegate: 'a',
			type: 'image',
			gallery: {enabled:true}
		});
	});

});
// menu

function openNav() {
	jQuery('#mySidenav').addClass('open');  
}

function closeNav() {
	jQuery('#mySidenav').removeClass('open');  
}